import {useJobContext} from 'contexts/JobContext';
import {PartialJob} from 'shared/types/PartialJob';
import {useAppSelector} from 'store/customer';
import {selectJobDetails} from 'components/customer/Confirmation/store/confirmationSlice';
import {useCaptureDeliveryInfo} from 'components/customer/Confirmation/helpers/useCaptureDeliveryInfo';

export const useCurrentDispatchMethod = () => {
    const {job} = useJobContext() as PartialJob;
    const jobDetails = useAppSelector(selectJobDetails);
    const captureDeliveryInfo = useCaptureDeliveryInfo();

    if (captureDeliveryInfo && jobDetails) {
        return jobDetails.dispatch;
    }

    return job?.dispatchMethod;
};
